<template>
  <b-card class="mb-4 p-2">
    <div class="d-flex align-items-center mb-3">
      <b-skeleton 
        v-if="loadingImage" 
        type="avatar" 
        size="40px" 
        class="mr-2"
      ></b-skeleton>      
      <b-img 
        v-else-if="authorImageSrc"
        :src="authorImageSrc" 
        alt="Foto do Autor" 
        class="author-photo rounded-circle mr-2"
      ></b-img>
      <div class="text-autor">
        {{ autor }} <br/>
        {{ especialidade }}
      </div>
    </div>

    <h4 class="title-card">{{ titulo }}</h4>
    <p class="text-card mt-4">{{ texto }}</p>
  </b-card>
</template>

<script>
import coverImageMixin from "../mixins/coverImageMixin";

export default {
  name: 'ArtigoCard',
  mixins: [coverImageMixin],
  props: {
    titulo: {
      type: String,
      required: true
    },
    texto: {
      type: String,
      required: true
    },
    autor: {
      type: String,
      required: true             
    },
    especialidade: {
      type: String,
      required: true             
    },    
    fotoAutor: {
      type: String,
      default: '' 
    }
  },
  data() {
    return {
      authorImageSrc: null,
      loadingImage: false
    };
  },
  watch: {
    fotoAutor: {
      immediate: true,
      async handler(newUrl) {
        await this.loadAuthorImage(newUrl);
      }
    }
  },
  methods: {
    async loadAuthorImage(url) {
      if (!url) {
        this.authorImageSrc = null;
        return;
      }

      this.loadingImage = true;
      try {
        // Limpa blobs anteriores usando a função do mixin
        this._revokeCoverImages();
        
        // Carrega a imagem dinamicamente através do método do mixin
        this.authorImageSrc = await this.loadCoverImage(url);
      } catch (error) {
        console.error("Erro ao carregar foto do autor:", error);
        this.authorImageSrc = null;
      } finally {
        this.loadingImage = false;
      }
    }
  }
}
</script>

<style scoped>
.author-photo {
    width: 40px;
    height: 40px;
    object-fit: cover; /* Garante que a foto não fique esticada */
}

.title-card { 
    font-size: 20px; 
    color: #212529; 
    font-family: "Trebuchet MS", sans-serif;
}

.text-card { 
    font-size: 12px; 
    color: #212529; 
    font-family: "Trebuchet MS", sans-serif;
}

.text-autor {
    color: var(--global-01-primary, #007A4A);
    font-family: "Trebuchet MS";
    font-size: 13px;
    font-weight: 700;
}
</style>